import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { ConceptoRedocumentacionService } from '../../../services/ConceptoRedocumentacionService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'redocumentacion_concepto',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. CR-01',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'redocumentacion_concepto_nombre',
    label: 'Descripción',
    type: 'text',
    col: 8,
    placeholder: 'Descripción del concepto',
    validators: [
      Validators.required("La descripción es obligatoria")
    ],
  },
];

export const ConceptoRedocumentacionForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await ConceptoRedocumentacionService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await ConceptoRedocumentacionService.guardar(values);
  };

  return (
    <CatalogForm
      title="Concepto de Redocumentación"
      subtitle="Catálogo de conceptos aplicables a redocumentaciones"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/Redocumentaciones"
    />
  );
};

export default ConceptoRedocumentacionForm;
